import type { InputTextPassThroughOptions, InputTextProps } from 'primevue/inputtext'

export interface TwnSearchInputProps {
  placeholder?: string
  /** The field's accessible name. It reaches the `<input>`, where a placeholder alone vanishes on typing. */
  ariaLabel?: string
  preIconClass?: string
  postIconClass?: string
  /** `medium` is Prime's own default, which `withDefaults` would otherwise turn back into `small`. */
  size?: InputTextProps['size'] | 'medium'
  emitOnClick?: boolean
  pt?: InputTextPassThroughOptions
  fieldClasses?: string | string[] | Record<string, boolean>
  inputClasses?: string | string[] | Record<string, boolean>
  debounceMs?: number
}

export const TWN_SEARCH_INPUT_DEFAULTS = {
  placeholder: 'Type to search',
  preIconClass: 'search',
  postIconClass: 'progress_activity',
  emitOnClick: false,
  size: 'small' as InputTextProps['size'],
  fieldClasses: '',
  inputClasses: '',
  debounceMs: 300
} as const
